export const generalVision = () => {
  const paymentMethodsContainer = document.querySelector('.general-vision-table .payment_methods .value .payment-icons')

  if (paymentMethodsContainer && paymentMethodsContainer.children.length > 3) {
    const numberOfHiddenIcons = paymentMethodsContainer.children.length - 3
    const allIcons = Array.from(paymentMethodsContainer.children)

    const firstThreeIcons = allIcons.slice(0, 3)
    allIcons.forEach((icon) => {
      if (!firstThreeIcons.includes(icon)) {
        icon.classList.add('d-none')
      }
    })

    const pmPlus = document.createElement('span')
    pmPlus.classList.add('pm-plus')
    pmPlus.innerHTML = '+ ' + numberOfHiddenIcons
    paymentMethodsContainer.after(pmPlus)

    pmPlus.addEventListener('click', () => {
      allIcons.forEach((icon) => {
        if (!firstThreeIcons.includes(icon)) {
          icon.classList.toggle('d-none')
        }
      })

      pmPlus.innerHTML = pmPlus.innerHTML === '+ ' + numberOfHiddenIcons ? 'hide' : '+ ' + numberOfHiddenIcons
    })
  }
}
